module.exports = __webpack_public_path__ + "img/antilopay.7fc5b42a.png";